export default __webpack_public_path__ + "static/media/yeongsam_crop.6708f74f.jpg";